import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the page was prerendered (build has static HTML with content), hydrate it.
// Otherwise mount a fresh root (normal dev / non-prerendered serve).
if (container.hasChildNodes()) {
  hydrateRoot(container, tree, {
    onRecoverableError: () => {}, // suppress benign hydration mismatches from client data fetching
  });
} else {
  createRoot(container).render(tree);
}
